<template lang="html">
  <div class="parameters">
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-center">
        <v-chip class="red">{{this.digits}} számjegy</v-chip>
        <v-chip class="blue">{{this.steps}} lépés</v-chip>
        <v-chip class="pink">{{this.method}} gyakorlás</v-chip>
        <v-chip class="teal darken-5">Sebesség: {{this.speed}}</v-chip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return {
      method: this.$store.getters.method,
      digits: this.$store.getters.digits,
      speed: this.$store.getters.speed,
      steps: this.$store.getters.steps,
    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip{
  color: #fff;
  margin: 10px 5px;
}
.parameters{
  @media(min-width:380px) and (max-width:600px){
    margin-top: 35px;
  }
}
</style>
